/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Component, OnInit } from '@angular/core';
import { NbMenuService, NbSuperSearchService, NbThemeService, NbSpinnerService } from '@nebular/theme';
import { ToasterService, ToasterConfig, BodyOutputType } from 'angular2-toaster';
import { ZAuthService } from './../services/';
import { UserModel } from './../models/';
import { MENU_ITEMS } from './menu';

@Component({
  selector: 'nb-layout-gen',
  styleUrls: ['./layout.component.scss'],
  templateUrl: './layout.component.html',
})
export class NbLayoutComponent implements OnInit {

  menu: any[] = [];
  userMenu = [{ title: 'Log out', link: '/auth/logout' }];
  private currentUser: UserModel;

  constructor(
    private searchService: NbSuperSearchService,
    private themeService: NbThemeService,
    private menuService: NbMenuService,
    private zAuthService: ZAuthService) { }

  public toasterConfig: ToasterConfig = new ToasterConfig({
    positionClass: 'toast-top-right',
    animation: 'fade',
    bodyOutputType: BodyOutputType.TrustedHtml
  });

  ngOnInit() {


    this.zAuthService.getCurrentUser().subscribe((user: UserModel) => {
      const self = this;

      this.menuService.addItems(
        MENU_ITEMS.filter(i => {
          if (i.guard) {
            return i.guard(self.zAuthService, user);
          }
          return true;
        }),
        'firstMenu',
      );
      this.currentUser = user;
    });

    this.searchService.onSearchSubmit().subscribe((data: { term: string, tag: string }) => {
      console.info(`term: ${data.term}, from search: ${data.tag}`);
    });
  }
  currentTheme = 'metro';

  changeTheme() {
    this.currentTheme = this.currentTheme === 'metro' ? 'blue' : 'metro';
    this.themeService.changeTheme(this.currentTheme);
  }

}



// WEBPACK FOOTER //
// ./src/app/layout-main/layout.component.ts